import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
///* Layout */
import Index from '@/views';
import Login from '@/views/login';
import page404 from '@/views/404';

export const constantRoutes = [
    {
        path: "/Login",
        name:"login",
        component: Login
    },
    {
        path: "/",
        name: "index",
        component: Index
    },
    {
        path: "/404",
        name: "404",
        component: page404
    }
];

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
});

const router = createRouter();
//导航守卫
router.beforeEach((to, from, next) => {
    let loginInfo = localStorage.getItem('loginInfo') ? JSON.parse(localStorage.getItem('loginInfo')) : {};
    let logined = !(loginInfo.token === "" || loginInfo.token === undefined);

    if (to.name === "login") {
        if (!logined) {
            next();
        } else {
            router.replace({ name: from.name })
        }
    } else {
        if (!logined) {
            next('/Login');
        } else {
            next();
        }
    }
})

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

export default router;
